import {
  INDICATOR,
  INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_TYPE,
} from '@/api/rest/resources/types/IndicatorProduct';
import { OrganizationUIStyle } from '@/api/rest/resources/types/organization';
import { useGetIndicatorProductSubscriptionConfigurations } from '@/hooks/useDashboardIndicatorProductSubscriptionConfiguration';
import { useIsStaffUser } from '@/hooks/useIsStaffUser';
import { useUIStyle } from '@/hooks/useUIStyle';
import { useIsLimitedAccessUser } from '@/pages/shared/hooks/useIsLimitedAccessUser';
import { useSelectedIndicatorProducts } from '@/pages/shared/indicators/hooks/useIndicatorProducts';

export const useDisplayUploadsPage = () => {
  const hasConservationUIStyle = useDisplayPlotOverviewPage();
  const { displayInSituDataUploadPage, displayMediaMapPage } = useDisplayInSituPages();
  const hasLimitedAccess = useIsLimitedAccessUser();

  if (hasLimitedAccess) {
    return false;
  }

  if (hasConservationUIStyle) {
    return true;
  }

  return displayInSituDataUploadPage || displayMediaMapPage;
};

export const useDisplayPlotOverviewPage = () => {
  return useUIStyle(OrganizationUIStyle.CONSERVATION);
};

export const useDisplayInSituPages = (): {
  displayInSituDataUploadPage: boolean;
  displayMediaMapPage: boolean;
} => {
  const orgIndicatorProducts = useSelectedIndicatorProducts();
  const ipConfigurations = useGetIndicatorProductSubscriptionConfigurations()?.data?.results ?? [];
  const isStaffUser = useIsStaffUser();

  const hasInsituDataIp = orgIndicatorProducts.some((ip) => ip.name === INDICATOR.IN_SITU_PACK);

  if (!hasInsituDataIp) {
    return {
      displayInSituDataUploadPage: false,
      displayMediaMapPage: false,
    };
  }

  if (isStaffUser) {
    return {
      displayInSituDataUploadPage: true,
      displayMediaMapPage: true,
    };
  }

  return {
    displayInSituDataUploadPage: ipConfigurations.some(
      (config) => config.type === INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_TYPE.DEFAULT,
    ),
    displayMediaMapPage: ipConfigurations.some(
      (config) => config.type === INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_TYPE.MEDIA_MAP,
    ),
  };
};
